import { motion, useReducedMotion } from "motion/react";
import { type ComponentProps, useRef } from "react";
import { createRevealVariants, REVEAL_AMOUNT } from "@/src/common/components/animated-section";
import { toEntranceVariant, useEntrance } from "@/src/common/hooks/use-entrance";

interface RevealProps extends ComponentProps<typeof motion.div> {
	delay?: number;
}

export function Reveal({ children, delay = 0, className, ...rest }: RevealProps) {
	const ref = useRef<HTMLDivElement>(null);
	const reduced = useReducedMotion() === true;
	const entrance = useEntrance(ref, { amount: REVEAL_AMOUNT, disabled: reduced });
	const variants = createRevealVariants(delay, reduced);

	return (
		<motion.div ref={ref} className={className} initial={false} animate={toEntranceVariant(entrance)} variants={variants} {...rest}>
			{children}
		</motion.div>
	);
}
